module.exports = __webpack_public_path__ + "static/media/tourney_rr.dfa90b23.png";